import React from "react"
import { FormikDropdown } from "../../../../../../../shared/components/forms/Formik"
import { CountryCode, BillReceiversFormValuesType } from "../../billReceiversTypes"
import { Box, MenuItem, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

export function DetailsCountrySelect() {
    return (
        <Box>
            <LocalizedStrict id="bill-receivers-create-dialog-country">
                <Typography mb="1rem" variant="subtitle1" textAlign="start">
                    Country:
                </Typography>
            </LocalizedStrict>
            <FormikDropdown<BillReceiversFormValuesType> name="country" fullWidth>
                <MenuItem value={CountryCode.DA}>
                    <LocalizedStrict id="bill-receivers-form-country-select-da">
                        <span>Denmark</span>
                    </LocalizedStrict>
                </MenuItem>
            </FormikDropdown>
        </Box>
    )
}
